// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".download-button[data-v-261cd145]{cursor:pointer;background-color:#00f;color:#fff;font-weight:700;text-align:center;text-transform:uppercase;display:flex;justify-content:center;align-items:center;height:48px}.download-button.green[data-v-261cd145]{background-color:#52ae43}.download-button.red[data-v-261cd145]{background-color:#c91e24}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
